import Fuse from 'fuse.js';
var THRESHOLD = 0.3;
// tslint:disable-next-line:no-any
export var Search = function (searchTerm, array, keys) {
    var fuse = new Fuse(array, {
        threshold: THRESHOLD,
        keys: keys
    });
    return fuse.search(searchTerm);
};
export var SortType = {
    Asc: 'asc',
    Desc: 'desc'
};



//////////////////
// WEBPACK FOOTER
// ./src/helpers/FuzzySearch.ts
// module id = 154
// module chunks = 0